// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__vjdTp","slider":"Skills_slider__mi7V+","autoRun":"Skills_autoRun__8IQYL","item":"Skills_item__j+cvs","content":"Skills_content__v2LWr"};